document.addEventListener("DOMContentLoaded", function () {
    const banner = document.getElementById("shopify-section-template--24901806489939__rich_text_ndqNeq");
    //check if banner exists
    if (!banner) {
        //console.log("No 'marquee' elements found");
        return;
    }

    //console.log("'marquee' elements found");


    //Find child element .rich-text__wrapper 
    const richTextWrapper = banner.querySelector(".rich-text__wrapper");
    //Remove class page-width
    richTextWrapper.classList.remove("page-width");

    //Find child element .rich-text__blocks center
    const richTextBlock = richTextWrapper.querySelector(".rich-text__blocks");
    //add class .marquee-banner to richTextBlocks
    richTextBlock.classList.add("marquee-banner");

    //Find child element rich-text__heading
    const richTextHeading = richTextBlock.querySelector(".rich-text__heading");

    // Remove classes starting by "animate--"
    // 1. Get the list of classes for the element
    const classes = richTextHeading.className.split(' ');
    // 2. Filter out classes that start with "animate--"
    const updatedClasses = classes.filter(className => !className.startsWith('animate--'));
    // 3. Update the element's class list
    richTextHeading.className = updatedClasses.join(' ');

    //remove class scroll-trigger animate--slide-in
    richTextHeading.classList.remove("scroll-trigger");

    //add class .marquee-track to richTextBlocks
    richTextHeading.classList.add("marquee-track");

    //Duplicate the text of richTextHeading and wrap it in a span
    const text = richTextHeading.innerHTML;
    richTextHeading.innerHTML = `<span>${text}</span>` + `<span>${text}</span>`;

});
